import type { PropsWithChildren } from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';

export const Callout: React.FC<CalloutProps> = ({ icon, children }) => {
	return (
		<Box sx={{ bg: 'sunrise.semantic.background.raised', display: 'flex', borderRadius: 'big' }} p="sunrise.6">
			<Icon
				icon={icon}
				size={16}
				color="typography-lightPrimary"
				backgroundColor="sunrise.semantic.icon.accent.primary"
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginRight: 'sunrise.4',
					minWidth: 32,
					minHeight: 32,
					borderRadius: 'full',
				}}
			/>
			<Flex sx={{ flexDirection: 'column', gap: 'sunrise.2' }}>{children}</Flex>
		</Box>
	);
};

type CalloutProps = PropsWithChildren<{
	icon: IconComponent;
	bodyVariant?: 'inline' | 'block';
}>;
